import { type Components, type Theme } from "@mui/material/styles";

export const timelineContent: Components<Theme>["MuiTimelineContent"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      paddingRight: 0,
      [theme.breakpoints.up("sm")]: {
        display: "flex",
        alignItems: "center",
        height: 35,
        paddingBlock: 0,
      },
    }),
  },
};
